import * as React from "react";
import type { SVGProps } from "react";

interface SubstituteOutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SubstituteOut = ({ cancelled = false, ...props }: SubstituteOutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M4.27 21.7a2 2 0 0 1-2-2V9.26c0-1.782 2.154-2.675 3.414-1.415l1.435 1.436 6.916-6.924a2 2 0 0 1 2.834.003l4.75 4.78a2 2 0 0 1-.008 2.828l-6.92 6.884 1.432 1.432c1.26 1.26.368 3.414-1.414 3.414z"
      />
      <path
        fill="#3A1919"
        d="M4.27 21a1.3 1.3 0 0 1-1.3-1.3V9.26c0-1.159 1.4-1.739 2.219-.92l1.93 1.931 7.411-7.42a1.3 1.3 0 0 1 1.842.003l4.75 4.78a1.3 1.3 0 0 1-.005 1.838l-7.417 7.38 1.928 1.927c.819.819.239 2.22-.92 2.22z"
      />
      <path
        fill="#FF1212"
        d="M4.27 19.7V9.26l2.39 2.39a.65.65 0 0 0 .92 0l7.87-7.88 4.75 4.78-7.88 7.84a.65.65 0 0 0 0 .92l2.389 2.388z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SubstituteOut;
